import React, { useState, useCallback, useRef, useEffect } from "react";
import debounce from "lodash/debounce";
import { Search } from "lucide-react";

export default function LocationAutocomplete({ value, onChange, onSelect, placeholder, readOnly, testId, required }) {
  const [results, setResults] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const search = useCallback(
    debounce(async (query) => {
      if (!query || query.length < 3) {
        setResults([]);
        return;
      }
      setLoading(true);
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query + ', Karnataka')}&limit=5`);
        const data = await res.json();
        setResults(data || []);
      } catch (e) {
        console.error("Nominatim fetch error", e);
      } finally {
        setLoading(false);
      }
    }, 500),
    []
  );

  const handleChange = (e) => {
    onChange(e.target.value);
    setShow(true);
    if (!readOnly) {
      search(e.target.value);
    }
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="relative">
        <input
          value={value}
          onChange={handleChange}
          onFocus={() => setShow(true)}
          className="input-dark w-full pr-8"
          required={required}
          readOnly={readOnly}
          data-testid={testId}
          placeholder={placeholder}
        />
        {loading && <Search className="w-4 h-4 text-[#00F0FF] absolute right-3 top-1/2 -translate-y-1/2 animate-pulse" />}
      </div>
      
      {show && !readOnly && results.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-[#142040] border border-[#2A3A5F] rounded-lg shadow-xl max-h-60 overflow-y-auto">
          {results.map((r, i) => (
            <div
              key={r.place_id || i}
              className="p-3 text-xs text-[#CBD5E1] hover:bg-[#2A3A5F] cursor-pointer border-b border-[#2A3A5F]/50 last:border-0 transition-colors"
              onClick={() => {
                onSelect(r.display_name);
                setShow(false);
              }}
            >
              {r.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
